import { Injectable } from '@angular/core';
import { LatLng } from '@models/google-location';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { DistancePipe } from '../../../shared/pipes/distance.pipe';
import { MapInfoWindowTemplateEntry } from '../../models/map-info-window-template';
import { MedicalType } from '../../models/medical-center';

@Injectable({
  providedIn: 'root'
})
export class MapContextService {
  dataList = new BehaviorSubject([]);
  serviceType = '';
  previousMap = {};
  location = {} as LatLng;
  medicalCriterias = [];
  distancePipe = new DistancePipe('es');

  constructor(private translate: TranslateService) {}

  setMarkers(services: any) {
    return (services || []).map((service: any) => {
      return {
        lat: Number(service.latitude),
        lng: Number(service.longitude),
        icon: this.setMapIcons(service, true, false),
        service
      };
    });
  }

  setMapIcons(service: any, isPWA: boolean, isIos: boolean) {
    let url = '';
    if (this.serviceType !== '') {
      switch (this.serviceType) {
        case 'OFFICE':
          if (isPWA) {
            url = 'assets/images/locator/icoMapOffices.png';
          } else {
            url = isIos
              ? 'www/assets/images/locator/icoMapOffices.png'
              : 'http://localhost/assets/images/locator/icoMapOffices.png';
          }
          break;
        case 'GARAGE':
          if (service.doorToDoor) {
            if (isPWA) {
              url = 'assets/images/locator/icoMapDoorToDoor.png';
            } else {
              url = isIos
                ? 'www/assets/images/locator/icoMapDoorToDoor.png'
                : 'http://localhost/assets/images/locator/icoMapDoorToDoor.png';
            }
          } else {
            if (service.type === '8') {
              if (isPWA) {
                url = 'assets/images/locator/icoMapCenter.png';
              } else {
                url = isIos
                  ? 'www/assets/images/locator/icoMapCenter.png'
                  : 'http://localhost/assets/images/locator/icoMapCenter.png';
              }
            } else {
              if (isPWA) {
                url = 'assets/images/locator/icoMapWorkshop.png';
              } else {
                url = isIos
                  ? 'www/assets/images/locator/icoMapWorkshop.png'
                  : 'http://localhost/assets/images/locator/icoMapWorkshop.png';
              }
            }
          }
          break;
        case 'MEDICAL':
          if (service.type === MedicalType.MAPFRE_CENTER) {
            if (isPWA) {
              url = 'assets/images/locator/icoMapPoli.png';
            } else {
              url = isIos
                ? 'www/assets/images/locator/icoMapPoli.png'
                : 'http://localhost/assets/images/locator/icoMapPoli.png';
            }
          } else {
            if (isPWA) {
              url = 'assets/images/locator/icoMapMed.png';
            } else {
              url = isIos
                ? 'www/assets/images/locator/icoMapMed.png'
                : 'http://localhost/assets/images/locator/icoMapMed.png';
            }
          }
          break;
        case 'DISCOUNT': {
          switch (service.type) {
            // Talleres old service
            case '5':
            // Talleres new service
            case 'T':
              if (isPWA) {
                url = 'assets/images/locator/pin_taller.png';
              } else {
                url = isIos
                  ? 'www/assets/images/locator/pin_taller.png'
                  : 'http://localhost/assets/images/locator/pin_taller.png';
              }
              break;
            // Gasolineras old service
            case '6':
            // Gasolineras new service
            case '3':
              if (isPWA) {
                url = 'assets/images/locator/icoGasStation.png';
              } else {
                url = isIos
                  ? 'www/assets/images/locator/icoGasStation.png'
                  : 'http://localhost/assets/images/locator/icoGasStation.png';
              }
              break;
            default:
              break;
          }
          break;
        }
        case 'road-assist-tracing':
          if (service.type === 'destination') {
            url = 'assets/images/road-assist-tracing/marker-destination.svg';
          }
          if (service.type === 'assistance-car') {
            url = 'assets/images/road-assist-tracing/marker-assistance-car.svg';
          }
          break;
        default:
          break;
      }
    }
    return url;
  }

  getServiceMapInfoWindowTemplateEntriesByType(
    service,
    serviceType: 'OFFICE' | 'GARAGE' | 'MEDICAL'
  ) {
    const servicePhoneEntries =
      service && service.phones
        ? this.getMapInfoWindowPhoneEntries(service.phones)
        : [];
    let mapInfoWindowTemplateEntries: MapInfoWindowTemplateEntry[] = [];
    switch (serviceType) {
      case 'OFFICE':
        mapInfoWindowTemplateEntries = [
          {
            type: 'header',
            text: service.name
          },
          {
            type: 'text',
            text: service.address.street
          },
          {
            type: 'text',
            text: this.distancePipe.transform(service.distance)
          },
          {
            id: 'BUTTON_MORE_INFO',
            type: 'button',
            text: this.translate.instant(
              'LOCATOR.SERVICES_LOCATOR.OFFICE.MORE_INFO'
            )
          }
        ];
        break;
      case 'GARAGE':
        mapInfoWindowTemplateEntries = [
          {
            type: 'header',
            text: service.name
          },
          {
            type: 'text',
            text: service.address.street
          },
          ...servicePhoneEntries,
          {
            id: 'LINK_OPEN_MAP_URI',
            type: 'icon-text',
            iconUrl: 'assets/images/locator/route.png',
            text: this.translate.instant('LOCATOR.SERVICES_LOCATOR.ROUTE')
          },
          {
            id: 'BUTTON_MORE_INFO',
            type: 'button',
            text: this.translate.instant(
              'LOCATOR.SERVICES_LOCATOR.OFFICE.MORE_INFO'
            )
          }
        ];
        break;
      case 'MEDICAL':
        mapInfoWindowTemplateEntries = [
          {
            type: 'header',
            text: service.name
          },
          {
            type: 'text',
            text: service.address.street
          },
          ...servicePhoneEntries,
          {
            id: 'LINK_OPEN_MAP_URI',
            type: 'icon-text',
            iconUrl: 'assets/images/locator/route.png',
            text: this.translate.instant(
              'LOCATOR.SERVICES_LOCATOR.MEDICAL_CENTERS.LIST.ROUTE'
            )
          },
          {
            id: 'BUTTON_MORE_INFO',
            type: 'button',
            text: this.translate.instant(
              'LOCATOR.SERVICES_LOCATOR.MEDICAL_CENTERS.LIST.MORE_INFO'
            )
          }
        ];
        break;
      default:
        break;
    }
    return mapInfoWindowTemplateEntries;
  }

  getMapInfoWindowPhoneEntries(phones: string[]) {
    if (!phones || !phones.length) {
      return [];
    }
    return phones
      .filter((curr, idx) => {
        return curr && idx < 2 && curr.toUpperCase().indexOf('FAX') === -1;
      })
      .map(phone => {
        return {
          type: 'icon-ref',
          text: phone,
          iconUrl: 'assets/images/locator/phone.png',
          href: `tel:${phone}`
        } as MapInfoWindowTemplateEntry;
      });
  }

}
